import { render, staticRenderFns } from "./ModalSelectFolderProject.vue?vue&type=template&id=385a1c56"
import script from "./ModalSelectFolderProject.vue?vue&type=script&lang=js"
export * from "./ModalSelectFolderProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports